__turbopack_context__.v({
  "arrow": "archival-label-viewer-module-scss-module__nXjOyG__arrow",
  "back": "archival-label-viewer-module-scss-module__nXjOyG__back",
  "close": "archival-label-viewer-module-scss-module__nXjOyG__close",
  "container": "archival-label-viewer-module-scss-module__nXjOyG__container",
  "forward": "archival-label-viewer-module-scss-module__nXjOyG__forward",
  "isDisabled": "archival-label-viewer-module-scss-module__nXjOyG__isDisabled",
  "isFullscreen": "archival-label-viewer-module-scss-module__nXjOyG__isFullscreen",
  "js-iv__trigger": "archival-label-viewer-module-scss-module__nXjOyG__js-iv__trigger",
});
